<script setup lang="ts">
interface Props {
	confirmationQuestion: string
	isDialogVisible: boolean
	confirmTitle: string
	cancelTitle: string
	primaryColor?: string
}

interface Emit {
	(e: "update:isDialogVisible", value: boolean): void
	(e: "confirm", value: boolean): void
}

const props = defineProps<Props>()

const emit = defineEmits<Emit>()

const unsubscribed = ref(false)
const cancelled = ref(false)

const updateModelValue = (val: boolean) => {
	emit("update:isDialogVisible", val)
}

const onConfirmation = () => {
	emit("confirm", true)
	updateModelValue(false)
	unsubscribed.value = true
}

const onCancel = () => {
	emit("confirm", false)
	emit("update:isDialogVisible", false)
	cancelled.value = true
}
</script>

<template>
	<!-- 👉 Confirm Dialog -->
	<VDialog max-width="500" :model-value="props.isDialogVisible" @update:model-value="updateModelValue">
		<VCard class="text-center px-10 py-6">
			<VCardText>
				<VBtn icon variant="outlined" color="warning" class="my-4" style="block-size: 88px; inline-size: 88px; pointer-events: none">
					<span class="text-5xl">!</span>
				</VBtn>

				<h6 class="text-lg font-weight-medium">
					{{ props.confirmationQuestion }}
				</h6>
			</VCardText>

			<VCardText class="d-flex align-center justify-center gap-2">
				<VBtn variant="elevated" :color="!!props?.primaryColor ? props.primaryColor : `error`" @click="onConfirmation">
					{{ confirmTitle }}
				</VBtn>

				<VBtn color="secondary" variant="tonal" @click="onCancel">
					{{ cancelTitle }}
				</VBtn>
			</VCardText>
		</VCard>
	</VDialog>
</template>
